import React, { Component } from 'react'
import '../card.css'

class CardHolder extends Component {

    render() {
        return (
            <div className="cards-holder">
                {this.props.children}
            </div>
        )
    }
}

export default CardHolder